import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import apiCDS from "../../services/apiCDS";
import Carousel from "../../components/Carousel";
import Container from "../../components/Container";
import Banner from "../../components/Banner";
import * as S from "./styles";

const ProfessorDatails = (props) => {
  const [professor, setProfessor] = useState([]);
  const [loading, setLoading] = useState(false);
  const [redirectToError, setRedirectToError] = useState(false);

  const id = props.match.params.id;

  const loadAuthor = async () => {
    await apiCDS.get(`/authors/${id}/courses`).then((response) => {
      setProfessor(response.data);
      setLoading(true);
    });
  };

  useEffect(() => {
    if (id === "30") {
      setRedirectToError(true);
    } else {
      loadAuthor(id);
    }
  }, [id]);

  if (redirectToError) {
    return <Redirect to="/error" />;
  }

  return (
    <Container type={"clean"}>
      {!loading ? (
        <div className={"spinner"} />
      ) : (
        <>
          <Banner />
          <S.Wrapper>
            <div className="block1">
              <S.SubTitle>{professor.name}</S.SubTitle>
              <S.TeacherInfo>{professor.description}</S.TeacherInfo>
            </div>
            <div className="block2">
              <S.SubTitle bold>Cursos</S.SubTitle>
              {professor.courses.length > 0 && (
                <Carousel
                  items={professor.courses}
                  maxWidth={420}
                  anchor={true}
                />
              )}
            </div>
          </S.Wrapper>
        </>
      )}
    </Container>
  );
};

export default ProfessorDatails;
